import { SimpleGrid, Text } from "@mantine/core";
import React, { useEffect } from "react";
import TextInput from "../../../../components/Input/TextInput";

const CommissionDropdown = ({ form }) => {
  console.log("CommissionDropdown form", form.values.commissions);

  useEffect(() => {
    const salesPerson1FrontGross = form?.values?.commissions?.salesPerson1?.frontGross
      ? parseFloat(form?.values?.commissions?.salesPerson1?.frontGross)
      : 0;
    const salesPerson1BackGross = form?.values?.commissions?.salesPerson1?.backGross
      ? parseFloat(form?.values?.commissions?.salesPerson1?.backGross)
      : 0;

    const salesPerson2FrontGross = form?.values?.commissions?.salesPerson2?.frontGross
      ? parseFloat(form?.values?.commissions?.salesPerson2?.frontGross)
      : 0;
    const salesPerson2BackGross = form?.values?.commissions?.salesPerson2?.backGross
      ? parseFloat(form?.values?.commissions?.salesPerson2?.backGross)
      : 0;

    const salesManagerFrontGross = form?.values?.commissions?.salesManager?.frontGross
      ? parseFloat(form?.values?.commissions?.salesManager?.frontGross)
      : 0;
    const salesManagerBackGross = form?.values?.commissions?.salesManager?.backGross
      ? parseFloat(form?.values?.commissions?.salesManager?.backGross)
      : 0;

    const financeManagerFrontGross = form?.values?.commissions?.financeManager?.frontGross
      ? parseFloat(form?.values?.commissions?.financeManager?.frontGross)
      : 0;
    const financeManagerBackGross = form?.values?.commissions?.financeManager?.backGross
      ? parseFloat(form?.values?.commissions?.financeManager?.backGross)
      : 0;

    const totalFrontGross = salesPerson1FrontGross + salesPerson2FrontGross + salesManagerFrontGross + financeManagerFrontGross;
    const totalBackGross = salesPerson1BackGross + salesPerson2BackGross + salesManagerBackGross + financeManagerBackGross;

    const totalCommission = totalFrontGross + totalBackGross;

    form.setFieldValue("totalCommission", totalCommission);
  }, [
    form.values.commissions.salesPerson1.frontGross,
    form.values.commissions.salesPerson1.backGross,
    form.values.commissions.salesPerson2.frontGross,
    form.values.commissions.salesPerson2.backGross,
    form.values.commissions.salesManager.frontGross,
    form.values.commissions.salesManager.backGross,
    form.values.commissions.financeManager.frontGross,
    form.values.commissions.financeManager.backGross,
  ]);

  return (
    <SimpleGrid cols={3}>
      <Text size={"sm"} mt={"md"}>
        Sales Person 1
      </Text>
      <TextInput placeholder="Front Gross Flat" form={form} validateName="commissions.salesPerson1.frontGross" size="xs" />
      <TextInput placeholder="Back Gross Flat" form={form} validateName="commissions.salesPerson1.backGross" size="xs" />
      <Text size={"sm"} mt={"md"}>
        Sales Person 2
      </Text>
      <TextInput placeholder="Front Gross Flat" form={form} validateName="commissions.salesPerson2.frontGross" size="xs" />
      <TextInput placeholder="Back Gross Flat" form={form} validateName="commissions.salesPerson2.backGross" size="xs" />
      <Text size={"sm"} mt={"md"}>
        Sales Manager
      </Text>
      <TextInput placeholder="Front Gross Flat" form={form} validateName="commissions.salesManager.frontGross" size="xs" />
      <TextInput placeholder="Back Gross Flat" form={form} validateName="commissions.salesManager.backGross" size="xs" />
      <Text size={"sm"} mt={"md"}>
        Finance Manager
      </Text>
      <TextInput placeholder="Front Gross Flat" form={form} validateName="commissions.financeManager.frontGross" size="xs" />
      <TextInput placeholder="Back Gross Flat" form={form} validateName="commissions.financeManager.backGross" size="xs" />
    </SimpleGrid>
  );
};

export default CommissionDropdown;
